/**
 * HashToggleHandler
 *
 * Handles anchor links with #tema:slug format to automatically open
 * and scroll to toggles with matching data-topic attributes.
 * Accounts for fixed navigation header when scrolling.
 */

export default class HashToggleHandler {
  constructor(app) {
    this.app = app
    this.init()
  }

  init() {
    // Handle hash on initial page load
    this.handleHash()

    // Listen for hash changes (when user clicks anchor links)
    window.addEventListener('hashchange', () => {
      this.handleHash()
    })
  }

  /**
   * Parse and handle the current URL hash
   */
  handleHash() {
    const hash = window.location.hash

    // Check if hash matches the #tema:slug format
    if (!hash || !hash.startsWith('#tema:')) {
      return
    }

    // Extract the slug after "tema:"
    const slug = hash.substring(6) // Remove "#tema:" prefix

    if (!slug) {
      return
    }

    // Find the toggle element with matching data-topic
    const toggleElement = document.querySelector(`[data-topic="${slug}"]`)

    if (!toggleElement) {
      console.warn(`No toggle found with data-topic="${slug}"`)
      return
    }

    // Find the trigger button within the toggle
    const triggerButton = toggleElement.querySelector('[data-toggle-trigger]')

    if (!triggerButton) {
      console.warn('Trigger button not found in toggle element', toggleElement)
      return
    }

    // Open the toggle if it's not already open
    if (!toggleElement.classList.contains('open')) {
      // Click the trigger button to open the toggle
      triggerButton.click()
    }

    // Scroll to the toggle with header offset
    this.scrollToElement(toggleElement)
  }

  /**
   * Scroll to an element accounting for the fixed header
   * @param {HTMLElement} element - The element to scroll to
   */
  scrollToElement(element) {
    // Wait for the toggle animation to complete
    setTimeout(() => {
      // Use scrollIntoView which respects the CSS scroll-margin-top property
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })
    }, 300) // Delay to allow toggle animation to complete
  }

  /**
   * Re-run hash handling (useful after page transitions)
   */
  refresh() {
    this.handleHash()
  }
}
